/**
 * This functionality will only work when changing pathname in route
 * and while coming back position of the webpage will be based on cached
 */
import { NAME as ROUTE_NAME } from './Route';
import {
  clearSavedScrolledPositions,
  getSavedScrollPosition,
  getScrolledPositionKey,
  setScrollPosition
} from './Utils';

/**
 * Route mapping to indicate weather scroll position needs to be maintained
 * Same or more rating suggests should cache scrolled position when switching between them
 */
const ROUTE_CONNECTION_MAPPING = {
  [ROUTE_NAME.CUSTOM_PAGE]: 1, // with route,
  [ROUTE_NAME.GROUP]: 3,
  [ROUTE_NAME.HOME]: 4,
  [ROUTE_NAME.GALLERY]: 5,
  [ROUTE_NAME.IMAGE_VIEW]: 5,
  [ROUTE_NAME.GLOBAL_REVIEW]: 6,
  [ROUTE_NAME.CUSTOMER_ORDERS]: 8,
  [ROUTE_NAME.CUSTOMER_ORDERS_DETAILS]: 9,
  [ROUTE_NAME.COMPANY_DETAIL]: 0
};

let historyLength = window.history.length;

const getHistoryLength = () => {
  historyLength = window.history.length;
  return historyLength;
};

const previousHistoryLength = () => historyLength;

export const shouldCacheScrollPositionForRoute = ({ previousRoute, currentRoute }) => {
  const currentRouteMappingScore = ROUTE_CONNECTION_MAPPING[currentRoute];
  const prevRouteMappingScore = ROUTE_CONNECTION_MAPPING[previousRoute];

  // add exceptions here if any
  const prevLength = previousHistoryLength();
  const newLength = getHistoryLength();
  if (
    prevLength === newLength &&
    currentRoute === previousRoute &&
    currentRoute === ROUTE_NAME.GALLERY
  ) {
    // exclude gallery view clicking on variants
    return false;
  }

  return currentRouteMappingScore >= prevRouteMappingScore;
};

const getPathName = () => window.location.pathname;

const getCachedScrolledPosition = (pathname) => {
  const key = getScrolledPositionKey(pathname);
  return getSavedScrollPosition(key);
};

const setCachedScrolledPosition = (pathname, position) => {
  const key = getScrolledPositionKey(pathname);
  if (!position) {
    setScrollPosition(key, null);
    return;
  }
  setScrollPosition(key, position);
};

export const clearCachedScrollPositions = () => {
  window.scrollTo(0, 0);
  clearSavedScrolledPositions();
};

export const clearCachedScrollPositionForPathname = (pathname) => {
  const position = getCachedScrolledPosition(pathname);
  if (!pathname || !position) {
    return;
  }
  setCachedScrolledPosition(pathname, null);
};

export const setCachedScrollPositionForPage = ({
  scrollTop = 0,
  scrollLeft = 0,
  pathname = ''
}) => {
  if (!scrollTop && !scrollLeft) {
    return;
  }
  setCachedScrolledPosition(pathname || getPathName(), { scrollTop, scrollLeft });
};

export const getCachedScrollPositionForPage = (pathname = '', remove) => {
  const path = pathname || getPathName();
  const scrollPosition = getCachedScrolledPosition(path);

  if (remove && scrollPosition) {
    clearCachedScrollPositionForPathname(path);
  }

  return scrollPosition;
};
